
import { useAuth } from "../../contexts/auth/useAuth";
import type { Transactions } from "../../types/Transaction";
import { roles } from "../../types/Users";
import FondInfo from "../Common/FondInfo";
import UserCompteInfo from "../Users/UserCompteInfo";
import TransactionEdit from "./TransactionEdit";
import { useTrads } from "../../contexts/trads/useTrads";

function TransactionItem({transaction}:{transaction:Transactions}){
    const {hasRole} = useAuth();
    const {translate}=useTrads();

    return (

            <div className="card">
                <FondInfo fondId={transaction.fond_id} /><br />
                {transaction.demande?
                <UserCompteInfo userId={transaction.demande.id_inscription} />
                :null}
                <div>
                    {translate('transaction_montant')} <span>{transaction.montant}</span><br />
                </div>
                <span>{transaction.communication}</span>
                {hasRole(roles.Administrators) ?
                    <div className="card-body">
                        <TransactionEdit transactionParam={transaction}  />
                    </div>
                :null}
            </div>  


       
    );
}
export default TransactionItem;